import { render, staticRenderFns } from "./temporaryDeliveryPlace_editor.vue?vue&type=template&id=6356b339&scoped=true"
import script from "./temporaryDeliveryPlace_editor.vue?vue&type=script&lang=js"
export * from "./temporaryDeliveryPlace_editor.vue?vue&type=script&lang=js"
import style0 from "./temporaryDeliveryPlace_editor.vue?vue&type=style&index=0&id=6356b339&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356b339",
  null
  
)

/* custom blocks */
import block0 from "./temporaryDeliveryPlace_editor.vue?vue&type=custom&index=0&blockType=div&style=max-width%3A403px%3Bmax-height%3A300px"
if (typeof block0 === 'function') block0(component)

export default component.exports